import * as Sentry from "@sentry/nextjs";
import {
  NOISY_SENTRY_ERROR_MESSAGES,
  scrubEvent,
  scrubTransaction,
} from "@/lib/sentry-pii-scrubber";

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
const release = process.env.NEXT_PUBLIC_SENTRY_RELEASE || undefined;
const environment = process.env.NEXT_PUBLIC_CLOUDFLARE_ENV || process.env.NODE_ENV || "production";

// Release Health: SDK v10+ emits browser sessions automatically via
// browserSessionIntegration. "Crash-Free Users" + "Release adoption"
// panels light up per release when `release` is set.
if (dsn) {
  Sentry.init({
    dsn,
    environment,
    release,
    tracesSampleRate: 0.05,
    sendDefaultPii: false,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    ignoreErrors: [...NOISY_SENTRY_ERROR_MESSAGES],
    // Drop errors whose top stack frame originates in a third-party script we
    // can't fix and shouldn't pay to ingest: the Razorpay checkout iframe (it
    // probes localhost + throws mixed-content during every checkout), Cloudflare
    // Turnstile, browser extensions, the Google Translate proxy, and analytics
    // SDKs. `beforeSend` (scrubEvent) already drops many by signature; denyUrls
    // is the cheap origin-level backstop that keeps these off the error budget.
    denyUrls: [
      /checkout\.razorpay\.com/,
      /api\.razorpay\.com/,
      /lumberjack\.razorpay\.com/,
      /cdn\.razorpay\.com/,
      /challenges\.cloudflare\.com/,
      /^chrome-extension:\/\//,
      /^moz-extension:\/\//,
      /^safari-extension:\/\//,
      /translate\.goog/,
      /googletagmanager\.com/,
      /clarity\.ms/,
    ],
    beforeSend: scrubEvent,
    beforeSendTransaction: scrubTransaction,
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
